import { CellInputBooleanComponent } from './cell-input-types/cell-input-boolean/cell-input-boolean.component';
import { CellInputDateTimeComponent } from './cell-input-types/cell-input-date-time/cell-input-date-time.component';
import { CellInputDurationComponent } from './cell-input-types/cell-input-duration/cell-input-duration.component';
import { CellInputFileComponent } from './cell-input-types/cell-input-file/cell-input-file.component';
import { CellInputGeoPointComponent } from './cell-input-types/cell-input-geo-point/cell-input-geo-point.component';
import { CellInputLinkComponent } from './cell-input-types/cell-input-link/cell-input-link.component';
import { CellInputNumberComponent } from './cell-input-types/cell-input-number/cell-input-number.component';
import { CellInputPhoneComponent } from './cell-input-types/cell-input-phone/cell-input-phone.component';
import { CellInputSecureTextComponent } from './cell-input-types/cell-input-secure-text/cell-input-secure-text.component';
import { CellInputSignatureComponent } from './cell-input-types/cell-input-signature/cell-input-signature.component';
import { CellInputTagComponent } from './cell-input-types/cell-input-tag/cell-input-tag.component';
import { CellInputTextComponent } from './cell-input-types/cell-input-text/cell-input-text.component';
import { CellInputTextMultiLineComponent } from './cell-input-types/cell-input-text-multi-line/cell-input-text-multi-line.component';
import { CellInputTimezoneComponent } from './cell-input-types/cell-input-timezone/cell-input-timezone.component';

export const CELL_INPUT_TYPES_COMPONENTS = [
  CellInputBooleanComponent,
  CellInputTextComponent,
  CellInputSecureTextComponent,
  CellInputTextMultiLineComponent,
  CellInputNumberComponent,
  CellInputPhoneComponent,
  CellInputDurationComponent,
  CellInputGeoPointComponent,
  CellInputTimezoneComponent,
  CellInputSignatureComponent,
  CellInputTagComponent,
  CellInputFileComponent,
  CellInputLinkComponent,
  CellInputDateTimeComponent,
];
